// SettingsMenu.js
import React, { useState } from "react";
import { editUser } from "../Admin/Api.js";
import "./SettingsMenu.css";
import DeleteUser from "../Login/DeleteUser.js"; // Importiere DeleteUser

const SettingsMenu = ({ handleNameChange, isOpen }) => {
  const [newName, setNewName] = useState(""); // Zustand für den neuen Namen
  const [error, setError] = useState(""); // Zustand für Fehlermeldung
  const [isEditing, setIsEditing] = useState(false); // Zustand für den Bearbeitungsmodus
  const username = localStorage.getItem("username"); // Benutzernamen aus localStorage holen

  const handleChangeName = async () => {
    if (newName.trim() === "") {
      alert("Bitte geben Sie einen neuen Benutzernamen ein.");
      return;
    }

    try {
      const data = await editUser(newName); 
      alert("Benutzername erfolgreich geändert!");
      localStorage.setItem("username", newName); 
      
      setIsEditing(false); 
      handleLogout();
    } catch (error) {
      console.error("Fehler beim Ändern des Namens:", error);
      setError("Fehler beim Ändern des Benutzernamens. Bitte versuche es später.");
    }
  };

  const handleLogout = () => {
    // Alle Daten aus localStorage entfernen und den Login-Status zurücksetzen
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('userId'); // Optional, falls du die User-ID im LocalStorage speicherst

    // Benutzer zum Login weiterleiten
    window.location.href = "/login";
  };

  return (
    <div className={`settings-menu ${isOpen ? 'open' : ''}`}>
      <ul>
        <li>
          <button onClick={() => setIsEditing(true)}>Name ändern</button>
          {isEditing && (
            <div className="edit-name-section">
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="Neuen Benutzernamen eingeben"
              />
              <div className="action-buttons">
                <button onClick={handleChangeName}>Speichern</button>
                <button onClick={() => setIsEditing(false)}>Abbrechen</button>
              </div>
            </div>
          )}
        </li>

        {error && <li className="error-message">{error}</li>}

        <li>
          <button onClick={handleLogout} className="logout-button">Logout</button> {/* Logout-Button */}
        </li>

        <li>
          <DeleteUser username={username} handleLogout={handleLogout} setError={setError} /> {/* Account löschen */}
        </li>

        {error && <li className="error-message">{error}</li>}
      </ul>
    </div>
  );
};

export default SettingsMenu;
